import type { EventData, SearchAnalyticsData } from '../types'

import { sendEvent } from '.'

export function trackSearchAnalytics(data: SearchAnalyticsData) {
  const API = {
    version: '0.0.1',
    name: 'search-analytics',
  }

  sendEvent(API, data)
}

export function trackPaymentEvent(data: EventData) {
  const PAYMENT_FORM_SUBMIT_START = {
    version: '0.0.1',
    name: 'payment',
  }

  sendEvent(PAYMENT_FORM_SUBMIT_START, data)
}
